import type { Video } from "@brookbush/types";

import { TabGroup, TabList, TabPanels } from "@headlessui/react";

import VideoInstructions from "./VideoInstructions";
import VideoRelated from "./VideoRelated";
import VideoTab from "./VideoTab";
import VideoTabPanel from "./VideoTabPanel";
import VideoTranscript from "./VideoTranscript";
import ExpressCard from "~/components/ExpressCard";

interface Props {
	video: Video;
	selectedIndex: number;
	setSelectedIndex: (index: number) => void;
}

const VideoTabs = ({ video, selectedIndex, setSelectedIndex }: Props) => {
	return (
		<aside className="col-span-full laptop:col-span-4 laptop:col-start-9 laptop:row-span-full">
			<div className="laptop:block hidden pb-6">
				<ExpressCard />
			</div>
			<TabGroup
				selectedIndex={selectedIndex}
				onChange={setSelectedIndex}
				className="sticky top-[8.4rem] flex flex-col gap-6"
			>
				<TabList className="-m-2 flex w-full gap-4 overflow-auto p-2">
					<VideoTab id="related-videos">Related Videos</VideoTab>

					{!!video.instructions?.length && (
						<VideoTab id="video-instructions">Instructions</VideoTab>
					)}

					{!!video.captions?.length && (
						<VideoTab id="video-transcript">Transcript</VideoTab>
					)}
				</TabList>
				<TabPanels>
					<VideoTabPanel>
						<VideoRelated video={video} />
					</VideoTabPanel>
					{!!video.instructions?.length && (
						<VideoTabPanel>
							<VideoInstructions video={video} />
						</VideoTabPanel>
					)}
					{!!video.captions?.length && (
						<VideoTabPanel>
							<VideoTranscript video={video} />
						</VideoTabPanel>
					)}
				</TabPanels>
			</TabGroup>
			<div className="col-span-full laptop:hidden pt-6">
				<ExpressCard />
			</div>
		</aside>
	);
};

export default VideoTabs;
